import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';
import {
  Badge,
  BadgeProps,
  List,
  ListItem,
  ListItemButton,
  Typography,
  styled,
  useTheme,
  ListItemButtonProps,
  darken,
} from '@mui/material';

import CardContainer from '../cards/CardContainer';
import { KundenDocFromTiles } from '../../hooks/useDocuments';
import useMedia from '../../hooks/useMedia';

// on hover change color of text in nested Typography
const DocumentGroupItem = styled(ListItemButton)<ListItemButtonProps>(
  ({ theme }) => ({
    borderRadius: '5px',
    borderStyle: 'solid',
    borderWidth: '1px',
    padding: '10px 20px ',
    '&:hover .MuiTypography-root': {
      color: darken(theme.palette.secondary.main, 1),
    },
  }),
);

const StyledBadge = styled(Badge)<BadgeProps>(() => ({
  '& .MuiBadge-badge': {
    top: -16,
    padding: '0 4px',
  },
}));

interface Props {
  documentGroups: KundenDocFromTiles[];
  seleced: string | null;
  setSelected: (group: string | null) => void;
  hasArrow?: boolean;
  title: string;
}

const DocumentGroupList: FC<Props> = observer(props => {
  const {
    documentGroups,
    seleced,
    setSelected,
    hasArrow = false,
    title,
  } = props;

  const { palette } = useTheme();
  const isMobile = useMedia('md');

  return (
    <CardContainer
      title={title}
      customStyle={{
        sx: {
          margin: isMobile ? 0 : '20px',
          marginTop: isMobile ? 3 : 5,
          marginLeft: isMobile ? 0 : 3,
          pb: 4,
        },
      }}
      hasArrow={hasArrow}
      iconOn
      iconColor={palette.primary.main}
      iconName={title}
    >
      <List
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {documentGroups?.map(documentGroup => {
          if (documentGroup.documents?.length)
            return (
              <ListItem>
                <DocumentGroupItem
                  key={documentGroup.tileTitle}
                  onClick={() => {
                    setSelected(documentGroup.tileTitle);
                  }}
                  sx={{
                    borderColor:
                      seleced === documentGroup.tileTitle
                        ? palette.primary.main
                        : palette.secondary.dark,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      textTransform: 'uppercase',
                    }}
                    color={
                      seleced === documentGroup.tileTitle
                        ? palette.primary.main
                        : palette.secondary.dark
                    }
                  >
                    {documentGroup.tileTitle}
                  </Typography>
                </DocumentGroupItem>
                <StyledBadge
                  key={documentGroup.tileTitle}
                  badgeContent={documentGroup.documents?.length}
                  color="secondary"
                />
              </ListItem>
              // </StyledBadge>
            );

          return null;
        })}
      </List>
    </CardContainer>
  );
});

export default DocumentGroupList;
